<script>
import ClearSelectionButton from './ClearSelectionButton.vue';
// ReportsFiltersInboxes.vue
import { mapGetters } from 'vuex';

export default {
  name: 'ReportsFiltersInboxes',
  components: { ClearSelectionButton },
  props: {
    // 🔥 NOVA PROP: Array de IDs de inboxes permitidas
    filteredInboxIds: {
      type: Array,
      default: null, // null = mostra todas as inboxes
    },
  },
  emits: ['inboxFilterSelection'],
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters({
      allInboxes: 'inboxes/getInboxes',
    }),

    // 🔥 COMPUTED: Retorna inboxes filtradas ou todas
    options() {
      // Se não houver filtro, retorna todas as inboxes
      if (!this.filteredInboxIds || this.filteredInboxIds.length === 0) {
        return this.allInboxes;
      }

      // Filtra apenas inboxes cujo ID está na lista permitida
      const filtered = this.allInboxes.filter(inbox =>
        this.filteredInboxIds.includes(inbox.id)
      );

      return filtered;
    },
  },
  watch: {
    // 🔥 WATCH: Limpa seleção inválida quando o filtro muda
    filteredInboxIds(newIds) {
      if (!newIds || newIds.length === 0) {
        // Se não há filtro, mantém a seleção
        return;
      }

      // Se a inbox selecionada não está mais disponível, limpa
      if (this.selectedOption && !newIds.includes(this.selectedOption.id)) {
        this.selectedOption = null;
        this.handleInput();
      }
    },
  },
  mounted() {
    this.$store.dispatch('inboxes/get');
  },
  methods: {
    clearSelection() {
      this.selectedOption = null;
      this.handleInput();
    },
    handleInput() {
      this.$emit('inboxFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      :placeholder="$t('INBOX_REPORTS.FILTER_DROPDOWN_LABEL')"
      label="name"
      track-by="id"
      :options="options"
      :option-height="24"
      :show-labels="false"
      @update:model-value="handleInput"
    >
      <template #clear>
        <ClearSelectionButton v-if="selectedOption" @clear="clearSelection" />
      </template>
    </multiselect>
  </div>
</template>
